import { createAction, props } from "@ngrx/store";
import IUserSkillResponse from "@skills-app/models/userSkillsResponse";
import IUser from "@skills-app/models/user";
import IConsultantProfile from "@skills-app/models/consultant-profile";
import ISkillNodeWithRating from "@skills-app/models/skillNodeWithRating";

const prefix = "[Consultant-Skill API]";

/*
|--------------------------------------------------------------------------
| Populate / hydrate data
|--------------------------------------------------------------------------
*/

export const populateUserSkills = createAction(
  `${prefix} Populate User Skills`,
  props<{ userSkillResponse: IUserSkillResponse }>(),
);

export const populateUser = createAction(
  `${prefix} Populate User`,
  props<{ user: IUser }>(),
);

export const populateCurrentUserProfile = createAction(
  `${prefix} Populate Current User Profile`,
  props<{ profile: IConsultantProfile }>(),
);

export const populateSelectedUserProfile = createAction(
  `${prefix} Populate Selected User Profile`,
  props<{ profile: IConsultantProfile }>(),
);

/*
|--------------------------------------------------------------------------
| Azure
|--------------------------------------------------------------------------
*/

export const triggerAzureSync = createAction(`${prefix} Triggle Azure Sync`);

/*
|--------------------------------------------------------------------------
| Skill selection
|--------------------------------------------------------------------------
*/

export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skillId: string }>(),
);

/*
|--------------------------------------------------------------------------
| Current user skill fetch
|--------------------------------------------------------------------------
*/

export const requestCurrentUserSkills = createAction(
  `${prefix} Request Current User Skills`,
);

export const requestCurrentUserSkillsSuccess = createAction(
  `${prefix} Request Current User Skills Success`,
  props<{ skills: ISkillNodeWithRating[] }>(),
);

export const requestCurrentUserSkillsError = createAction(
  `${prefix} Request Current User Skills Error`,
);

/*
|--------------------------------------------------------------------------
| Selected user skills
|--------------------------------------------------------------------------
*/

export const requestSelectedUserSkills = createAction(
  `${prefix} Request Selected User Skills`,
  props<{ azureId: string }>(),
);

export const requestSelectedUserSkillsSuccess = createAction(
  `${prefix} Request Selected User Skills Success`,
  props<{ skills: ISkillNodeWithRating[] }>(),
);

export const requestSelectedUserSkillsError = createAction(
  `${prefix} Request Selected User Skills Error`,
);

/*
|--------------------------------------------------------------------------
| User skill flags / counts
|--------------------------------------------------------------------------
*/

export const requestUserHasSkills = createAction(
  `${prefix} Request User Has Skills`,
);

export const requestUserHasSkillsSuccess = createAction(
  `${prefix} Request User Has Skills Success`,
  props<{ hasSkills: boolean }>(),
);

export const requestUserHasSkillsError = createAction(
  `${prefix} Request User Has Skills Error`,
);

export const requestAllUsersCount = createAction(
  `${prefix} Request All Users Count`,
);

export const requestAllUsersCountSuccess = createAction(
  `${prefix} Get All Users Count Success`,
  props<{ count: number }>(),
);

export const requestAllUsersCountError = createAction(
  `${prefix} Get All Users Count Error`,
);

export const requestAllSkillCount = createAction(
  `${prefix} Request All Skills Count`,
);

export const requestAllSkillCountSuccess = createAction(
  `${prefix} Get All Skills Count Success`,
  props<{ count: number }>(),
);

export const requestAllSkillCountError = createAction(
  `${prefix} Get All Skills Count Error`,
);

/*
|--------------------------------------------------------------------------
| Mutations
|--------------------------------------------------------------------------
*/

export const updateUserSkillSuccess = createAction(
  `${prefix} Update User Skill Success`,
);

export const updateUserSkillError = createAction(
  `${prefix} Update User Skill Error`,
);

export const deleteUserSkillSuccess = createAction(
  `${prefix} Delete User Skill Success`,
);

export const deleteUserSkillError = createAction(
  `${prefix} Delete User Skill Error`,
);
